export * from './delete-extra-vereinbarung.component';
export * from './delete-extra-vereinbarung.component.module';